// extracted by mini-css-extract-plugin
export var backdropBlur = "_kq-0";
export var contentCard = "_kq-5";
export var frame = "_kq-2";
export var image = "_kq-4";
export var imagePane = "_kq-3";
export var modal = "_kq-1";